<template>
  <div class="yh_harvest">
    <yh :_name="name"></yh>
  </div>
</template>

<script>
import { fn_pos_mid } from "../../assets/js/harvest";
import yh from "./canal";
export default {
  data() {
    return {
      name: "大运河文化"
    };
  },
  components: {
    yh
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@import url("../../assets/css/index");*/
@import url("../../assets/css/else.css");
@import url("../../assets/css/harvest.css");
#harvest_search_box3 {
  padding-left: 115px;
  padding-right: 106px;
}
.harest_btn_box.canal_ {
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/harvest/canal_.vue